import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Status from "../views/Status.vue";
import Success from "../views/Success.vue";


Vue.use(VueRouter);

const routes = [
  
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/Status",
    name: "Status",
    component: Status
  },
  {
    path: "/Success",
    name: "Success",
    component: Success
  }
  
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
